import { useEffect, useState } from 'react';
import { useDebounceCallback } from 'usehooks-ts';
import type { SwiperRef } from 'swiper/react';

export function useDebouncedSwiperWidth(
    ref: React.MutableRefObject<SwiperRef | null>,
    delay = 300,
): number | null {
    const [width, setWidth] = useState<number | null>(null);

    const updateWidth = useDebounceCallback(() => {
        if (ref.current?.swiper && hasWidth(ref.current)) {
            setWidth((ref.current.swiper as { width: number }).width);
        }
    }, delay);

    useEffect(() => {
        window.addEventListener('resize', updateWidth);
        updateWidth();

        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [ref, updateWidth]);

    return width;
}

const hasWidth = (swiper: SwiperRef): swiper is SwiperRef & { swiper: { width: number } } =>
    'width' in swiper.swiper;
